module.exports = __webpack_public_path__ + "assets/img/B2.0393a603.png";